import { createActions, createState, createReducer } from 'reduxsauce-crud'

export const ConsumiblesCategoryRedux = createActions({}, {
  prefix: 'CONSUMIBLES_CATEGORY_',
  defaultActions: {
    get: true,
  },
})

const { Types, Creators } = ConsumiblesCategoryRedux
export const ConsumiblesCategoryTypes = Types
export default Creators

export const INITIAL_STATE = createState({}, {
  get: true,

})

export const reducer = createReducer(INITIAL_STATE, {}, {
  defaultActions: {
    get: true,
  },
  Types,
})



// WEBPACK FOOTER //
// ./src/Data/Redux/ConsumiblesCategoryRedux.js